import Image from '@atoms/Image';
import Text from '@atoms/Text';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { useEffect, useRef } from 'react';

export const ProductHowStructured = ({
    productHowStructured
}) => {
    const {
        question,
        title,
        titleSuffix = '?',
        cards,
        bgImages
    } = productHowStructured || {};
    const structureRefs = cards.map(() => useRef());
    const { width } = useWindowDimensions();
    const calculateHeight = (index, width) => {
        if (index < cards.length - 1) {
            const currentElement = structureRefs[index].current;
            const nextElement = structureRefs[index + 1].current;
    
            if (currentElement && nextElement) {
              const currentRect = currentElement.getBoundingClientRect();
              const nextRect = nextElement.getBoundingClientRect();
              // Adjust the calculation based on the relative positions of the elements
              const height = nextRect.top - currentRect.bottom + (width >= 768 ? 66 : 48);
              return `${height}px`;
            }
        }
    
        return '130px';
      };
    
    return (
        <section
            id="product-how-structured"
            className="relative flex flex-col w-full"
        >
            <div className="w-full py-8 md:py-12 xl:py-16 px-4 md:px-10 xl:px-16">
                <div className="flex flex-col md:flex-row justify-center items-center h4-semibold md:h3-semibold xl:h2-semibold">
                    <Text
                        content={<>
                            {question}<br className='md:hidden' /><span className='text-primary-500'>{title}{titleSuffix}</span>
                        </>}
                        htmlTag="h2"
                        className="whitespace-pre text-gray-500 text-center"
                    />
                </div>
            </div>
            <div className="w-full pl-16 pr-4 md:pl-24 md:pr-10 xl:pl-32 xl:pr-16 flex flex-col gap-6 xl:gap-10">
                {cards?.map(({ title, description }, index) => (
                    <div key={index} className="border border-secondary-300 shadow-md rounded-xl py-4 pl-11 pr-4 bg-basicWhite relative flex flex-col justify-center z-20">
                        <div className="bg-secondary-300 w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-full absolute -left-6 md:-left-[30px] z-40"  ref={structureRefs[index]}>
                            <Text
                                content={`0${index + 1}`}
                                className="text-secondary-900 h4-semibold md:h3-semibold relative top-[2px]"
                                id={`structure-${index}`}
                            />
                        </div>
                        <Text
                            content={title}
                            className="p4-semibold md:p1-semibold text-primary-500"
                            htmlTag='h3'
                        />
                        <Text
                            content={description}
                            className="p4-regular md:p2-regular text-basicBlack"
                        />
                        {index !== cards?.length - 1 ? (
                            <div className="absolute -left-11 md:-left-14 xl:-left-16 top-[50%]">
                                <div
                                    className={`border-[3px] border-primary-100 rounded-[32px] w-14 border-r-0`}
                                    style={{
                                        height: calculateHeight(index, width),
                                    }}
                                ></div>
                            </div>
                        ) : null}
                    </div>
                ))}
            </div>

            {bgImages?.left && (
                <div
                    style={{ pointerEvents: 'none' }}
                    className={`absolute hidden md:block md:-left-0 md:-top-[400px] xl:left-0 xl:top-[130px]`}
                >
                    <Image src={bgImages?.left} />
                </div>
            )}

            {bgImages?.right && (
                <div
                    style={{ pointerEvents: 'none' }}
                    className={`absolute hidden md:block md:-bottom-[840px] md:right-0 xl:top-[180px] xl:right-0`}
                >
                    <Image src={bgImages?.right} />
                </div>
            )}
        </section>
    );
}
